import type { FormMetadata } from './types';

/**
 * Parses a form's raw Metadata JSON string (Atlas_Forms.Metadata) into a typed
 * FormMetadata object.
 *
 * Returns null for empty, missing, or invalid JSON, and also for JSON that
 * parses but carries no usable Labels array — callers should treat a null
 * result as "this form has no labels, render it at menu root level" per spec.
 */
export function parseFormMetadata(metadataRaw: string | null | undefined): FormMetadata | null {
  if (!metadataRaw || !metadataRaw.trim()) {
    return null;
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(metadataRaw);
  } catch {
    return null;
  }

  if (
    !parsed ||
    typeof parsed !== 'object' ||
    !Array.isArray((parsed as FormMetadata).Labels) ||
    (parsed as FormMetadata).Labels!.length === 0
  ) {
    return null;
  }

  return parsed as FormMetadata;
}
